import DataTable from "react-data-table-component";
import { Card, CardBody, Col } from "reactstrap";
import StateSavingCardHeader from "./StateSavingCardHeader";
import { STATE_SAVING_COLUMN, STATE_SAVING_DATA } from "../../../../Data/DataTable/StateSavingData";

const StateSaving = () => {
  return (
    <Col sm="12">
      <Card>
        <StateSavingCardHeader />
        <CardBody>
          <div className="table-responsive">
            <DataTable data={STATE_SAVING_DATA} columns={STATE_SAVING_COLUMN} striped pagination />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default StateSaving;
